import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _positionStyles;

function _templateObject22() {
  var data = _taggedTemplateLiteral(["", ":hover & {\n    position: absolute;\n    visibility: visible;\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n      position: absolute;\n      visibility: visible;\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background: ", ";\n  border-radius: 3px;\n  padding: 12px 24px;\n  text-align: center;\n  font-weight: normal;\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.24);\n  z-index: 9999;\n  visibility: hidden;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #fff;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      left: -14px;\n      &:after {\n        ", "\n        transform: translate(0, -50%);\n        right: -20px;\n        top: 50%;\n        border-color: transparent transparent transparent ", ";\n      }\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      bottom: 50%;\n      left: -4px;\n      transform: translate(-100%, 50%);\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      bottom: -14px;\n      &:after {\n        ", "\n        bottom: 100%;\n        left: 14px;\n        border-color: transparent transparent ", " transparent;\n      }\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      bottom: -4px;\n      transform: translate(0, 100%);\n      left: 0;\n      margin-left: -8px;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      bottom: -14px;\n      &:after {\n        ", "\n        margin-left: -10px;\n        bottom: 100%;\n        left: 50%;\n        border-color: transparent transparent ", " transparent;\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      bottom: -4px;\n      transform: translate(-50%, 100%);\n      left: 50%;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      bottom: -14px;\n      &:after {\n        ", "\n        bottom: 100%;\n        right: 14px;\n        border-color: transparent transparent ", " transparent;\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      bottom: -4px;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      bottom: -4px;\n      transform: translate(0, 100%);\n      right: 0;\n      margin-right: -8px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      right: -14px;\n      &:after {\n        ", "\n        transform: translate(0, -50%);\n        right: 100%;\n        top: 50%;\n        border-color: transparent ", " transparent transparent;\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      bottom: 50%;\n      transform: translate(100%, 50%);\n      right: -4px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      top: -14px;\n      &:after {\n        ", "\n        top: 100%;\n        right: 14px;\n        border-color: ", " transparent transparent transparent;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      top: -4px;\n      transform: translate(0, -100%);\n      right: 0;\n      margin-right: -8px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      top: -14px;\n      &:after {\n        ", "\n        margin-left: -10px;\n        top: 100%;\n        left: 50%;\n        border-color: ", " transparent transparent transparent;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      top: -4px;\n      transform: translate(-50%, -100%);\n      left: 50%;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      top: -14px;\n      &:after {\n        ", "\n        top: 100%;\n        left: 14px;\n        border-color: ", " transparent transparent transparent;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      top: -4px;\n      transform: translate(0, -100%);\n      left: 0;\n      margin-left: -8px;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { mineShaft } from '../../styles/colors';
export var positions = {
  topLeft: 'top-left',
  top: 'top',
  topRight: 'top-right',
  right: 'right',
  bottomRight: 'bottom-right',
  bottom: 'bottom',
  bottomLeft: 'bottom-left',
  left: 'left'
};
export var types = {
  default: '',
  arrow: 'arrow'
};
var carrotStyles = "\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-width: 10px;\n  border-style: solid;\n";
var positionStyles = (_positionStyles = {}, _defineProperty(_positionStyles, positions.topLeft, {
  default: css(_templateObject()),
  arrow: css(_templateObject2(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.top, {
  default: css(_templateObject3()),
  arrow: css(_templateObject4(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.topRight, {
  default: css(_templateObject5()),
  arrow: css(_templateObject6(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.right, {
  default: css(_templateObject7()),
  arrow: css(_templateObject8(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.bottomRight, {
  default: css(_templateObject9()),
  hover: css(_templateObject10()),
  arrow: css(_templateObject11(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.bottom, {
  default: css(_templateObject12()),
  arrow: css(_templateObject13(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.bottomLeft, {
  default: css(_templateObject14()),
  arrow: css(_templateObject15(), carrotStyles, mineShaft)
}), _defineProperty(_positionStyles, positions.left, {
  default: css(_templateObject16()),
  arrow: css(_templateObject17(), carrotStyles, mineShaft)
}), _positionStyles);
export var ToolTipWrapper = styled.div(_templateObject18());
export var ToolTipStyled = styled.div(_templateObject19(), mineShaft, function (_ref) {
  var position = _ref.position,
      type = _ref.type;
  return css(_templateObject20(), positionStyles[position].default, type === types.arrow && positionStyles[position].arrow);
}, function (_ref2) {
  var forceShowToolTip = _ref2.forceShowToolTip;
  return forceShowToolTip && css(_templateObject21());
}, function (_ref3) {
  var hoverEnabled = _ref3.hoverEnabled;
  return hoverEnabled && css(_templateObject22(), ToolTipWrapper);
});